import { PlusOutlined, RightOutlined } from '@ant-design/icons'
import { Empty, Flex, Select, Spin } from 'antd'
import dayjs from 'dayjs'
import React, { useCallback, useEffect, useState } from 'react'
import { useParams, useSearchParams } from 'react-router-dom'
import {
  getCaseDetail,
  getCaseDetailByStep,
  getCaseIssueDetail,
} from '../../api/aopsCase.api'
import CaseIssueModal from '../../components/apos/case/CaseIssueModal'
import CaseTrackBoardModal from '../../components/apos/case/CaseTrackBoardModal'
import './caseTrackBoard.scss'
// import CaseTrackBoardCard from '../../components/apos/case/CaseTrackBoardCard'
const returnSatusText = {
  OCCURRED: '발생',
  WAIT: '대기',
  COMPLETE: '완료',
}
const AopsCaseDetailPage = () => {
  const { caseId } = useParams()
  const [searchParams] = useSearchParams() // 1. 검색 파라미터 훅 사용
  const stepParam = searchParams.get('step') // 2. 'step'이라는 이름의 값 가져오기
  const [loading, setLoading] = useState(true)
  const [openIssueModal, setOpenIssueModal] = useState(false)
  const [caseSummary, setCaseSummary] = useState(null)
  const [issueList, setIssueList] = useState(null)
  const [issueDetail, setIssueDetail] = useState(null)
  const [selectedIssueId, setSelectedIssueId] = useState(null)
  const [selectedStep, setSelectedStep] = useState(null) // null = ALL
  // 케이스 수정 모달 관련 상태값 추가
  const [openCaseEditModal, setOpenCaseEditModal] = useState(false)
  const [caseDetail, setCaseDetail] = useState(null)

  const fetchCaseDetail = async (caseWorkId) => {
    try {
      const res = await getCaseDetail(caseWorkId)
      setCaseDetail(res)
      if (res) setOpenCaseEditModal(true)
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    if (stepParam) {
      // URL에 step이 있으면 해당 스텝으로 필터링 실행 (숫자로 맞춰야 Select 옵션 value와 매칭되어 title 표시)
      const stepNum = Number(stepParam)
      setSelectedStep(Number.isNaN(stepNum) ? stepParam : stepNum)
      fetchFilteredIssues(stepParam)
    } else {
      setSelectedStep(null)
      fetchInitialData()
    }
  }, [caseId, stepParam])
  const fetchInitialData = async () => {
    setLoading(true)
    try {
      const res = await getCaseDetail(caseId)
      setCaseSummary(res.caseWork || {})
      // 처음에는 전체 리스트를 보여줍니다.
      setIssueList(res.issueList || [])
    } catch (error) {
      console.error('초기 로딩 에러:', error)
    } finally {
      setLoading(false)
    }
  }

  // 2. 이슈 리스트만 따로 불러오는 함수 (필터링용)
  const fetchFilteredIssues = useCallback(
    async (stepValue) => {
      setLoading(true)
      try {
        if (stepValue === null) {
          // '전체' 선택 시 다시 전체 상세 호출
          const res = await getCaseDetail(caseId)
          setIssueList(res.issueList || [])
        } else {
          // 특정 스텝 선택 시 필터링 API 호출
          const res = await getCaseDetailByStep(caseId, stepValue)
          setIssueList(res.issueList || [])
        }
      } catch (error) {
        console.error('필터링 에러:', error)
        setIssueList([])
      } finally {
        setLoading(false)
      }
    },
    [caseId],
  )

  // 마운트 시 실행
  useEffect(() => {
    fetchInitialData()
  }, [caseId])

  // 3. 스텝 변경 시 실행될 핸들러
  const handleStepChange = (value) => {
    setSelectedStep(value)
    fetchFilteredIssues(value)
  }

  const handleIssueDetail = async (issueId, step) => {
    setSelectedIssueId(issueId)
    try {
      const res = await getCaseIssueDetail(issueId)
      // console.log(res, 'res issueId')
      setIssueDetail({ ...res, currentStep: step })
      setOpenIssueModal(true)
    } catch (error) {
      console.log(error)
      return null
    }
  }

  // 모달에서 생성/수정/삭제 후 호출: summary(워크플로우 카운트) + 이슈 리스트 모두 갱신
  const refreshList = useCallback(async () => {
    setLoading(true)
    try {
      const res = await getCaseDetail(caseId)
      setCaseSummary(res.caseWork || {})
      if (selectedStep === null) {
        setIssueList(res.issueList || [])
      } else {
        const stepRes = await getCaseDetailByStep(caseId, selectedStep)
        setIssueList(stepRes.issueList || [])
      }
    } catch (error) {
      console.error('새로고침 에러:', error)
      setIssueList([])
    } finally {
      setLoading(false)
    }
  }, [caseId, selectedStep])

  return (
    <>
      <section className="case-track-board">
        <div className="case-track-board-header">
          <p className="title">케이스 추적 대시보드</p>
          <p className="description">
            케이스를 직접 만들어 대시보드로 확인할 수 있어요
          </p>
          <button
            type="primary"
            className={'register-case-issue-button'}
            onClick={() => setOpenIssueModal(true)}
          >
            이슈 생성
            <PlusOutlined style={{ marginLeft: '4px', fontWeight: `700` }} />
          </button>
        </div>
        {/* <Spin spinning={true} size="large" /> */}
        {/* 케이스 대시보드 */}
        <section
          className="case-track-card-container full-width"
          style={{ position: 'relative', marginTop: '16px' }}
        >
          {loading && (
            <Flex
              justify="center"
              align="center"
              style={{
                width: '100%',
                height: '100%',
                position: 'absolute',
                backgroundColor: 'rgba(0, 0, 0, 0.08)',
                borderRadius: '12px',
                zIndex: 10,
              }}
            >
              <Spin spinning={true} size="large" />
            </Flex>
          )}
          <div className="case-track-card">
            <div
              className="content-header"
              style={{ justifyContent: 'center', alignItems: 'center' }}
            >
              <p className="title" style={{ textAlign: 'center' }}>
                {caseSummary?.emojiText && `${caseSummary.emojiText} `}
                {caseSummary?.caseTitle || ''}
              </p>
              <button
                type="primary"
                className={'case-edit-button'}
                onClick={() => fetchCaseDetail(caseId)}
              >
                수정하기
                <RightOutlined className="case-edit-button-icon" />
              </button>
            </div>
            <div className="content-body">
              <Flex
                align="center"
                className="workflow-flow"
                style={{ justifyContent: 'center' }}
              >
                {caseSummary?.caseWorkProcessStates?.map((item, index) => {
                  const hasProblem =
                    item?.waitProblemCount &&
                    item?.waitProblemCount?.overdueWaitCount > 0
                  return (
                    <React.Fragment key={index + '-workflow'}>
                      <div
                        className={`workflow-stage ${hasProblem ? '' : 'no-issue'}`}
                        onClick={() => handleStepChange(item.step)} // 클릭 시 필터링!
                        style={{
                          cursor: 'pointer',
                          padding: '10px',
                          minWidth: '110px',
                          maxWidth: '110px',
                          borderRadius: '8px',
                        }}
                      >
                        <div className="stage-number">{item.issueCount}</div>
                        <div
                          className="stage-label"
                          style={{
                            textOverflow: 'unset',
                            whiteSpace: 'normal',
                          }}
                        >
                          {item.title}
                        </div>
                        {hasProblem && (
                          <div className={'stage-sub-status'}>
                            <span className="sub-status-total">
                              {item?.waitProblemCount?.overdueWaitCount}
                            </span>
                          </div>
                        )}
                      </div>
                      {index !==
                        caseSummary?.caseWorkProcessStates?.length - 1 && (
                        <RightOutlined className="workflow-arrow" />
                      )}
                    </React.Fragment>
                  )
                })}
              </Flex>
            </div>
          </div>
        </section>

        <section className="case-track-detail-list">
          <div className="detail-list-wrapper">
            <table className="detail-list-table">
              <thead className="detail-list-thead">
                <tr>
                  <th>
                    <div className="issue-status-selector">
                      <Select
                        className="form-select"
                        value={selectedStep}
                        onChange={handleStepChange}
                        style={{ width: `300px` }}
                        placeholder="이슈 상태 선택"
                      >
                        <Select.Option value={null}>전체</Select.Option>
                        {caseSummary?.caseWorkProcessStates?.map(
                          (item, index) => (
                            <Select.Option
                              key={index + '-select-option'}
                              value={item.step}
                            >
                              {item.title}
                            </Select.Option>
                          ),
                        )}
                      </Select>
                    </div>
                  </th>
                  <th>발생일</th>
                  <th>SLA</th>
                  {/* <th>메모</th> */}
                  <th>메모</th>
                </tr>
              </thead>
              <tbody>
                {/* 이슈 리스트 */}
                {issueList?.map((issueItem) => (
                  <tr
                    style={{ cursor: 'pointer' }}
                    key={issueItem.issueId + '-issue-list'}
                    onClick={() =>
                      handleIssueDetail(issueItem.issueId, issueItem.step)
                    }
                  >
                    <td>
                      <div className="status-cell">
                        <span className="status-badge">{issueItem.step}</span>
                        <span className="status-text">
                          {issueItem.issueTitle}
                        </span>
                        {issueItem.hasProblem && (
                          <span className="issue-tag">이슈 발생</span>
                        )}
                      </div>
                    </td>
                    <td>
                      <div className="date-cell">
                        <span>
                          {dayjs(issueItem.createdAt).format('YYYY-MM-DD')}
                        </span>
                      </div>
                    </td>
                    <td>
                      <div className="date-cell strong">
                        <span>
                          {dayjs(issueItem.slaDateTime).format('YYYY-MM-DD')}
                        </span>
                      </div>
                    </td>
                    {/* <td className="memo-cell">{issueItem.issueTitle}</td> */}
                    <td className="memo-cell">{issueItem.memo || '--'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            {issueList?.length === 0 && (
              <Flex
                justify="center"
                align="center"
                className="empty-list"
                style={{ boxShadow: 'none' }}
              >
                <Empty description="이슈 목록이 없습니다." />
              </Flex>
            )}
          </div>
        </section>
      </section>
      <CaseIssueModal
        open={openIssueModal}
        onClose={() => setOpenIssueModal(false)}
        fetchCaseDetail={refreshList}
        caseWorkId={caseId}
        issueDetail={issueDetail}
        selectedIssueId={selectedIssueId}
        setSelectedIssueId={setSelectedIssueId}
        setIssueDetail={setIssueDetail}
      />
      <CaseTrackBoardModal
        open={openCaseEditModal}
        onClose={() => setOpenCaseEditModal(false)}
        fetchCaseList={refreshList}
        caseDetail={caseDetail}
      />
    </>
  )
}

export default AopsCaseDetailPage
